module.exports = __webpack_public_path__ + "img/jisc.93009e39.png";